module.exports = __webpack_public_path__ + "img/incubator-3.7ff7e6de.webp";